<template>
  <div class="caseView">
    <!-- 标题图片 -->
    <div class="title"  >
      <img src="./img/title.png" alt="">
    </div>
    <!-- 内容 -->
    <p class="titleText">案例分析</p>
    <PcCaseList :case-title="item"  v-for="item in caseTitleList" :key="item.ID"/>
    <!-- <div class="caseBox">
      <div class="caseBoxTop">
        <p>医药</p>
      </div>
      <div class="caseBoxBottom">
        <div class="caseBoxBottomItem" v-for="item in 8" :key="item" @click="goCaseShow">
          <div class="itemImg">
            <img  src="./img/caseboxItem.png" alt="">
          </div>
          <p class="itemTitle">德尔康终端+电商全设备集成项目</p>
          <p class="itemInfo">通过实施物流信息系统，德尔康医药建立了对仓储物流中心运作的精细化作业管理，作业效率和数据准确性得到很…</p>
        </div>

      </div>
    </div> -->
    <!-- 如果没数据显示 -->
    <!-- <div class="noContent" >
            <img src="~@/assets/img/noContent.png" alt="">
    </div> -->
  </div>
</template>

<script>
import PcCaseList from './components/caseList/PcCaseList.vue';
// 引入获取解决方案类型
import { customerCaseType } from '@/api/client'
export default {
  data() {
    return {
      caseTitleList:[]
    }
  },
  components:{PcCaseList},
  mounted () {
    this.customerCaseType()
  },
  methods: {
    goCaseShow () {
      this.$router.push('/caseShow')
    },
        // 获取客户案例类型
    async customerCaseType () {
      const res = await customerCaseType()
      // console.log(res, 'customerCaseTypecustomerCaseType')
      if (res.Msg === '获取成功') {
        this.caseTitleList = res.Data
        // this.$store.commit('getCaseTitle', res.Data)
      }
    },

  }

}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.caseView{
  width: 100%;
  overflow: hidden;
  .title{
    width: 100%;
    height: 460px*$sun;
    margin-bottom: 50px*$sun;
    cursor: pointer;
    img{
      width: 100%;
      height: 460px*$sun;
    }
  }
}
.titleText{
  width: 100%;
  text-align: center;
  font-size: 40px*$sun;
  font-weight: 500;
  margin: 0;
  margin-bottom: 60px*$sun;
}
.caseBox{
    width: 1400px*$sun;
    margin: auto;

}
// 大标题
.caseBoxTop{
  width: 100%;
  height: 45px*$sun;
  border-bottom: 4px*$sun solid #EEE;
  margin-bottom: 10px;
    p{
      margin: 0;
      width: 180px*$sun;
      height: 45px*$sun;
      border-bottom: 4px*$sun solid #2380E1;
      font-size: 22px*$sun;
      font-weight: 700;
      color: #2380E1;
      text-align: center;
    }
}
// 案例列表
.caseBoxBottom{
  width: 1400px*$sun;
  margin: auto;
  overflow: hidden;
  margin-bottom: 80px*$sun;
  p{
    margin: 0;
  }
  .caseBoxBottomItem{
      float:left;
      width: 282px*$sun;
      height: 320px*$sun;
      margin-right: 90px*$sun;
      .itemImg{
      width: 266px*$sun;
      height: 137px*$sun;
      margin: auto;
      margin-bottom: 44px*$sun;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .itemTitle{
        width: 100%;
        height: 24px*$sun;
        margin-bottom: 29px*$sun;
        font-size: 18px*$sun;
        font-weight: bold;
        color: #333333;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space:nowrap; //溢出不换行
      }
      .itemInfo{
        width: 100%;
        height: 85px*$sun;
        font-size: 16px*$sun;
        font-weight: 500;
        line-height: 28px*$sun;
        color: #666666;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
  }
  .caseBoxBottomItem:nth-of-type(4n) {
        margin-right: 0;
    }
}
// 没信息是显示
.noContent{
  display: flex;
  justify-content: center;
  // margin-top: 20px*$sun;
  margin-bottom: 60px*$sun;
}
</style>
